export default __webpack_public_path__ + "static/image/slider2.bf40fcd2.jpg";